export const UNTITLED = 'untitled'
export const GET = 'get'
export const CALL = 'call'
export const WATCH = 'watch'
export const UNWATCH = 'unwatch'
export const REF = 'ref'
export const REF_EXEC = 'ref_exec'
